import React from 'react';
import type { QuoteStatus } from '../../types/quote';
const tones: Record<QuoteStatus, string> = {
  Kladde: 'bg-canvas-deep text-ink-soft border-line',
  Sendt: 'bg-status-warn/10 text-status-warn border-status-warn/35',
  Accepteret: 'bg-status-ok/10 text-status-ok border-status-ok/35',
  Afvist: 'bg-danger/10 text-danger border-danger/30',
  Udløbet: 'bg-transparent text-ink-muted border-line'
};
export function QuoteStatusBadge({
  status,
  className = ''
}: {
  status: QuoteStatus;
  className?: string;
}) {
  return <span className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border px-2.5 py-1 text-xs font-medium ${tones[status]} ${className}`} data-id="element-540" data-mp="1doqanzp6x8na">
      <span className="h-1.5 w-1.5 rounded-full bg-current opacity-70" aria-hidden="true" data-id="element-541" data-mp="1mr9ccgh8pf7y" />
      {status}
    </span>;
}